module.exports = __webpack_public_path__ + "static/media/19ESCAP27.b74a3975.jpg";